<template>
  <div class="app-container">
    <el-row :gutter="24" type="flex" justify="center">
        <el-col :sm="16" :sx="24">
          <search class="search" />
        </el-col>
      </el-row>
      <div v-loading="loading">
        <div v-for="categorySite in siteList" :key="categorySite.id">
          <h4
            :id="'category-' + categorySite.id"
            :ref="'category-' + categorySite.id"
          >
            <svg-icon icon-name="tag" class="client-category-icon" />
            <span class="client-category-name">{{
              categorySite.categoryName
            }}</span>
          </h4>
          <el-row :gutter="24">
            <el-col
              :sm="6"
              :sx="24"
              class="mb15"
              v-for="site in categorySite.sites"
              :key="site.id"
            >
              <site-card :site="site" />
            </el-col>
          </el-row>
        </div>
      </div>
  </div>
</template>
<script setup>
import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'

import SiteCard from '@/components/SiteCard'
import Search from '@/layout/client/components/Search'

import { categorySiteList } from '@/api/client/search'
import { useClientCategories } from '@/composables/useClientCategories'

const route = useRoute()
const setCategories = useClientCategories()

const loading = ref(true)
const siteList = ref([])
const searchContent = ref(route.params.searchContent)

/**
 * 获取数据
 */
async function getData() {
  loading.value = true
  const {
    data: { categories, sites }
  } = await categorySiteList(searchContent.value)
  // 搜索页左侧分类应跟随当前搜索结果刷新
  setCategories(categories)
  siteList.value = sites
  loading.value = false
}

watch(
  () => route.params.searchContent,
  value => {
    // 路由参数变化时先清空旧结果，避免左侧栏和内容短暂显示上一次搜索数据
    loading.value = true
    siteList.value = []
    setCategories([])
    searchContent.value = value
    getData()
  },
  { immediate: true }
)
</script>
